import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/AboutItemSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/AppDownload.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/Banner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/BetterSolutions.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/Convert.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvertProvider"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/ConvertContext.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/Country.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/Feature.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/MissionVision.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MoreSolutions"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/MoreCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/StackCard.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/TeamSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/Testimonial.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/TextSlider.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/TimelineSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/WalletBannerSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/WalletItemsSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/_sections/WalletReviewsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["RedirectIfReference"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/RedirectIfReference.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralSystem"] */ "/home/kaydmoc/public_html/belyfted.com/app/_partials/ReferralSystem.jsx");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/node_modules/cookies-next/lib/client/context.js");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/node_modules/react-hot-toast/dist/index.mjs");
